<ng-container *transloco="let t">
  @if (disableAddressInMap()) {
    <pxw-input-text
      name="simpleAddress"
      [label]="t('address.addressLabel')"
      [placeholder]="t('address.addressPlaceholder')"
      [(ngModel)]="street"
      [displayErrors]="isFormSubmitted()"
      required
    />
  } @else {
    <pxw-map-address
      style="margin-bottom: 0.5em"
      [label]="t('address.addressLabel')"
      [placeholder]="t('address.addressPlaceholder')"
      [helper]="t('address.addressHelper')"
      [searchCenter]="geoIpState()!"
      [required]="true"
      [(addressDetails)]="addressDetails"
      (addressDetailsChange)="onUpdateAddressDetails($event)"
      [displayStaticMapPreview]="true"
      [selectAddressText]="t('address.selectAddress')"
      [locateOnMapText]="t('address.locateOnMapText')"
      [searchText]="t('address.searchText')"
      [wrongLocationText]="t('address.wrongLocationText')"
      [locationNotFoundText]="t('address.locationNotFoundText')"
      [selectOnMapText]="t('address.selectOnMapText')"
      [wrongAddressesText]="t('address.wrongAddressesText')"
      [readyText]="t('address.readyText')"
      [geolocationErrorText]="t('address.geolocationError')"
      [searchErrorText]="t('address.searchError')"
      [mapInstructions]="mapInstructions()"
      [countryCodes]="countryCodes()!"
      [isFormSubmitted]="isFormSubmitted()"
    />
  }

  <ng-content />

  @if (addressDetails() || disableAddressInMap()) {
    <pxw-input-radio-group
      class="place-type"
      name="placeType"
      [label]="t('address.placeTypeLabel')"
      [options]="placeTypes()"
      [(ngModel)]="placeType"
      [valueKey]="'type'"
      [labelKey]="'label'"
      required
      [displayErrors]="isFormSubmitted()"
      [collapsible]="true"
    >
      <pxw-button
        class="unselect-button"
        color="blue"
        size="sm"
        [rounded]="true"
        appareance="solid"
      >
        <pxw-icon class="ui-clickable" style="flex: 0 0 auto" icon="edit" />
      </pxw-button>
      <ng-template #itemTemplate let-placeType>
        <div class="ui-input__input place-type-item">
          {{ placeType.label }}
        </div>
      </ng-template>
    </pxw-input-radio-group>

    @if (placeType()) {
      @switch (placeType()) {
        @case ('housing-state') {
          <pxw-input-text
            name="placeName"
            [maxLength]="placeNameMaxLength"
            [label]="t('address.housingStatePlaceNameLabel')"
            [placeholder]="t('address.housingStatePlaceNamePlaceholder')"
            [(ngModel)]="placeName"
            [displayErrors]="isFormSubmitted()"
            required
          />
          <pxw-input-text
            name="lot"
            [maxLength]="lotMaxLength"
            [label]="t('address.housingStateLotLabel')"
            [placeholder]="t('address.housingStateLotPlaceholder')"
            [(ngModel)]="lot"
            [displayErrors]="isFormSubmitted()"
            required
          />
        }
        @case ('business') {
          <pxw-input-text
            name="placeName"
            [maxLength]="placeNameMaxLength"
            [label]="t('address.businessPlaceNameLabel')"
            [placeholder]="t('address.businessPlaceNamePlaceholder')"
            [(ngModel)]="placeName"
            [displayErrors]="isFormSubmitted()"
            required
          />
        }
        @case ('building') {
          <pxw-input-text
            name="placeName"
            [maxLength]="placeNameMaxLength"
            [label]="t('address.buildingPlaceNameLabel')"
            [placeholder]="t('address.buildingPlaceNamePlaceholder')"
            [(ngModel)]="placeName"
            [displayErrors]="isFormSubmitted()"
            required
          />
          <pxw-input-text
            name="floorAndNumber"
            [maxLength]="floorAndNumberMaxLength"
            [label]="t('address.buildingFloorAndNumberLabel')"
            [placeholder]="t('address.buildingFloorAndNumberPlaceholder')"
            [(ngModel)]="floorAndNumber"
            [displayErrors]="isFormSubmitted()"
            required
          />
        }
        @case ('other') {
          <pxw-input-text
            name="placeName"
            [maxLength]="placeNameMaxLength"
            [label]="t('address.otherPlaceNameLabel')"
            [placeholder]="t('address.otherPlaceNamePlaceholder')"
            [(ngModel)]="placeName"
            [displayErrors]="isFormSubmitted()"
            required
          />
        }
      }
      <pxw-input-text
        name="references"
        [maxLength]="referencesMaxLength"
        [label]="t('address.referencesLabel')"
        [placeholder]="t('address.referencesPlaceholder')"
        [helper]="t('address.referencesHelper')"
        [displayErrors]="isFormSubmitted()"
        [required]="referencesRequired()"
        [(ngModel)]="references"
      />
    }
  }

  <!-- Modal para agregar código postal -->
  <pxw-modal-dialog
    #postalCodeModal
    [title]="t('shippingOptions.addPostalCode')"
    type="alert"
    [acceptText]="t('shippingOptions.confirmPostalCode')"
    [confirmDisabled]="!canConfirmPostalCode()"
    [showCloseButton]="false"
    (isOpenChange)="onModalOpenChange($event)"
  >
    <ng-template #modalContent>
      <pxw-alert type="info" size="sm" display="inline-block" style="margin-bottom: 1.5em">
        {{ t('shippingOptions.postalCodeRequiredHelper') }}
      </pxw-alert>

      <pxw-select-box
        name="province"
        [label]="t('shippingOptions.provinceLabel')"
        [placeholder]="t('shippingOptions.provincePlaceholder')"
        [options]="provinces"
        [(ngModel)]="selectedProvince"
        [valueKey]="'code'"
        [labelKey]="'name'"
        [required]="true"
        [displayErrors]="false"
        [messages]="{
          required: t('shippingOptions.provinceRequired'),
        }"
      />

      <pxw-input-text
        name="postalCode"
        [label]="t('shippingOptions.postalCodeLabel')"
        [placeholder]="t('shippingOptions.postalCodePlaceholder')"
        [(ngModel)]="manualPostalCode"
        [required]="true"
        [pattern]="/^[0-9]{4}$/"
        [displayErrors]="false"
        [messages]="{
          required: t('shippingOptions.postalCodeRequired'),
          pattern: t('shippingOptions.postalCodeInvalid'),
        }"
      />

      <p class="postal-code-search-helper">
        {{ t('shippingOptions.postalCodeSearchHelper') }}
        <a href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank" rel="noopener">
          {{ t('shippingOptions.postalCodeSearchLink') }}
        </a>
      </p>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
